// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck file
import { SceneComponent } from './virtualStaging/Scene.component';

export class ThreeInstance extends SceneComponent {
  public get() {
    return this.context.three;
  }
}

export const threeInstanceComponentType = 'mp.threeInstance';
export const makeThreeInstance = () => new ThreeInstance();
